import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "components/Header";
import axios from "axios";
import { server } from "server";
import { Link } from "react-router-dom";

import FormRetrait from "scenes/formretrait";
import PopupVente from "components/PopupVente";
import DataGridRetraitToolbarDetails from "components/DataGridRetraitToolbarDetails";
import {
  CancelPresentationSharp,
  CheckBox,
  DeleteOutline,
  ListAltOutlined,
} from "@mui/icons-material";
import PopupConfirm from "components/PopupConfirm";
import FlexBetween from "components/FlexBetween";
import { toast } from "react-toastify";

const Retrait = () => {
  const theme = useTheme();

  // values to be sent to the backend
  const [openPopup, setOpenPopup] = useState(false);
  const [product, setProduct] = useState([]);
  const [userId, setUserId] = useState("");
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    axios.get(`${server}/product/get-all-products`).then((res) => {
      setProduct(res.data.allproducts);
    });
  }, []);

  const handleDelete = (id) => {
    axios
      .delete(`${server}/product/delete-product/${id}`)
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const columns = [
    {
      field: "createdAt",
      headerName: "Creé le",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Nom",
      flex: 1,
    },
    {
      field: "desc",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "price_vente",
      headerName: "Prix de vente",
      flex: 1,
    },
    {
      field: "stock",
      headerName: "Quantité en Stock",
      flex: 1,
    },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/productEdit/" + params.row.id}>
              <button className="userListEdit">Edit</button>
            </Link>
            <DeleteOutline
              className="userListDelete"
              onClick={() =>
                setUserId(params.row.id) || setOpenDelete(!openDelete)
              }
            />
          </>
        );
      },
    },
  ];
  const row = [];

  product &&
    product.forEach((item) => {
      row.push({
        id: item._id,
        name: item.name,
        desc: item.desc,
        price_vente: item.price_vente,
        stock: item.stock,
        createdAt: item.createdAt.slice(0, 10),
      });
    });

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Les produits en attente"
        subtitle="Liste des Produits en attenete dans le stock"
      />
      <Link to="/pendingproduct">
        <Button
          color="secondary"
          variant="contained"
          style={{ marginBottom: "6px" }}
          onClick={() => setOpenPopup(!openPopup)}
        >
          <ListAltOutlined />
          Les Produits
        </Button>
      </Link>
      <Box
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={row}
          columns={columns}
          components={{ Toolbar: DataGridRetraitToolbarDetails }}
          componentsProps={{
            toolbar: { openPopup, setOpenPopup },
          }}
        />
      </Box>
      <PopupVente
        title="Formulaire des retraits"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <FormRetrait setOpenPopup={setOpenPopup} />
      </PopupVente>

      <PopupConfirm
        title="Voulez-vous supprimer le produit "
        open={openDelete}
        setOpen={setOpenDelete}
      >
        <FlexBetween>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginBottom: "1px" }}
            onClick={() => setOpenDelete(!openDelete) || handleDelete(userId)}
          >
            <CheckBox />
            OUI
          </Button>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginBottom: "1px" }}
            onClick={() => setOpenDelete(!openDelete)}
          >
            <CancelPresentationSharp />
            Non
          </Button>
        </FlexBetween>
      </PopupConfirm>
    </Box>
  );
};

export default Retrait;
